import * as models from "app/models/requireme";
import { any, generatePushID, assertUnreachable } from "keautils";
import { cancelarViajeApp, finalizarViajeApp, syncViaje, borrarViajeDeDispositivo } from "../logic";
import * as kea from "kea-react";


type Entity = models.ViajeAppIniciado;

/**Si no se puede agregar una entrega incompleta, devuelve la razon, si no, devuele true */
export function puedeAgregarIncompleta(state: Entity, idDestino: number): "tieneRealizadas" | true | "tieneIncompleta" {
    const realizadas = any(state.model.EntregasRealizadas, x => x.IdDireccionDestino == idDestino);
    const incompletas = any(state.model.EntregasIncompletas, x => x.IdDireccionDestino == idDestino);

    if (realizadas) return "tieneRealizadas";
    if (incompletas) return "tieneIncompleta";

    return true;
}

/**Sincroniza el viaje y si el usuario no tiene viaje en la app, le pregunta para realizar el borrado del viaje */
export async function onSincronizar(): Promise<void> {
    const result = await syncViaje();
    if (result != true) {
        switch (result) {
            case "errorConexion":
                await kea.message("No hay conexión", "", "error");
                break;
            case "sinViaje":
                if (await kea.yesno("Sin viaje, ¿borrar viaje actual?", "El usuario actual no tiene un viaje iniciado en el servidor, ¿borrar el viaje actualmente iniciado en el dispositivo?")) {
                    await borrarViajeDeDispositivo();
                }
                break;
            case "errorSubida":
                await kea.message("Error al subir los datos", "No se pudieron subir los datos del viaje", "error");
                break;
            default: return assertUnreachable(result);
        }
    }
}

export function onAgregarIncompleta(state: Entity, idDestino: number, motivo: string): Entity {
    const nuevaEntrega: models.EntregaIncompletaViajeAppModel = {
        ClaveUnica: generatePushID(),
        Fecha: new Date(),
        IdDireccionDestino: idDestino,
        Motivo: motivo
    };
    return {
        ...state,
        model: {
            ...state.model,
            EntregasIncompletas: [
                ...state.model.EntregasIncompletas,
                nuevaEntrega
            ]
        }
    }
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/destinos/logic.ts